// Shared formatting for the Phase 3 performance UI.

// Map a KPI/health status to a visual tone (semantic, separate from the accent).
export const STATUS_TONE = {
  Ahead: "good",
  "On Track": "good",
  Healthy: "good",
  Behind: "warn",
  "Needs Attention": "warn",
  "At Risk": "bad",
  Critical: "bad",
  "No Data": "muted",
  "Target Not Configured": "muted",
  "Not Started": "muted",
  "Insufficient Data": "muted",
};

const compact = new Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 });
const plain = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

// A raw number, never NaN/Infinity in the UI (backend already sends null).
export function fmtNum(v) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return Math.abs(n) >= 10000 ? compact.format(n) : plain.format(n);
}

// Format a metric value with its unit ("%", "x", a currency code, or none).
export function fmtMetric(v, unit) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  if (unit === "%") return `${plain.format(n)}%`;
  if (unit === "x") return `${plain.format(n)}×`;
  if (unit && /^[A-Z]{3}$/.test(unit)) return `${unit} ${fmtNum(n)}`;
  return fmtNum(n);
}

export function fmtDateTime(iso) {
  if (!iso) return "never";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "never";
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
